import { snakeCase } from 'lodash-es';
import { wrapComment } from '../../utils/strings.js';
import BaseField from './BaseField.js';
export class BaseWrapperField extends BaseField {
    static MULTIDIMENSIONAL_FIELD_NAME = 'innerItems';
    items;
    dimensions = 1;
    innerType;
    constructor(data) {
        super({ ...data });
        this.items = data.items;
        this.proto.definition = [
            ...this.items.proto.comments.map(wrapComment).flat(),
            ...this.items.proto.definition,
        ];
        this.innerType = this.items.proto.type;
        if (this.items instanceof BaseWrapperField) {
            this.dimensions = this.items.dimensions + 1;
            const wrapperName = `[[name.pc]]WrapperLvl${this.dimensions - 2}`;
            this.proto.definition.push(`message ${wrapperName} { ${this.innerType} ${snakeCase(BaseWrapperField.MULTIDIMENSIONAL_FIELD_NAME)} = 1; }`);
            this.innerType = wrapperName;
        }
        this.proto.definition.push(...this.proto.comments.map(wrapComment).flat());
        this.references = this.items.references;
        this.proto.comments = [];
    }
}
//# sourceMappingURL=BaseWrapperField.js.map